const advisors = {
  state: [
    {
      name: 'Ivan',
      lname: 'Tomic',
      photo: require('@/assets/team/ivan.png'),
      pos: 'Advisor',
    },
    {
      name: 'Ian',
      lname: 'Friend',
      photo: require('@/assets/team/ian.jpg'),
      pos: 'Advisor',
    },
    {
      name: 'Patrick',
      lname: 'Boismenu',
      photo: require('@/assets/team/patrick.jpg'),
      pos: 'Advisor',
    },
  ],
}

export default advisors
